import { AvatarHover, AvatarSelected } from "@components/avatar";
import { ellipsis } from "polished";
import styled from "styled-components";

import Avatar from "../../components/avatar/Avatar";
import { getFocusBorderElement, T_PLAIN_small_hig } from "../../global.style";

export const AvatarStyledCompany = styled(Avatar)`
    margin-right: 42px;
`;

export const StyledAvatarSelector = styled.div`
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    row-gap: 20px;
    column-gap: 20px;
`;

export const AvatarWrapper = styled.div <{
    $isSelected: boolean;
}>`
    position: relative;
    ${props => props.$isSelected && AvatarSelected};
    cursor: pointer;
    
    &:hover:after {
        ${AvatarHover}
    }

    ${getFocusBorderElement({ offset: -3, borderRadius: "3px" })};
`;

export const CompanyAvatarWithNameWrapper = styled.div`
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const CompanyAvatarName = styled.span`
    ${ellipsis()};
    ${T_PLAIN_small_hig};
    margin-left: 8px;
`;